import {
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import axios from "axios";

const themeColor = "#286a94";

const emptyLanguage = {
  languageName: "",
  level: "",
  canSpeak: false,
  canWrite: false,
  canRead: false,
};

const LANGUAGE_LEVELS = [
  { value: "BEGINNER", label: "Beginner" },
  { value: "INTERMEDIATE", label: "Intermediate" },
  { value: "ADVANCED", label: "Advanced" },
  { value: "FLUENT", label: "Fluent" },
];

export const MANUAL_LANGUAGES = [
  { name: "Abkhazian", code: "ab" },
  { name: "Afar", code: "aa" },
  { name: "Afrikaans", code: "af" },
  { name: "Albanian", code: "sq" },
  { name: "Amharic", code: "am" },
  { name: "Arabic", code: "ar" },
  { name: "Armenian", code: "hy" },
  { name: "Assamese", code: "as" },
  { name: "Aymara", code: "ay" },
  { name: "Azerbaijani", code: "az" },

  { name: "Bashkir", code: "ba" },
  { name: "Basque", code: "eu" },
  { name: "Bengali", code: "bn" },
  { name: "Bhutani (Dzongkha)", code: "dz" },
  { name: "Bhojpuri", code: "bh" },
  { name: "Bislama", code: "bi" },
  { name: "Bosnian", code: "bs" },
  { name: "Breton", code: "br" },
  { name: "Bulgarian", code: "bg" },
  { name: "Burmese", code: "my" },

  { name: "Catalan", code: "ca" },
  { name: "Chinese (Simplified)", code: "zh" },
  { name: "Corsican", code: "co" },
  { name: "Croatian", code: "hr" },
  { name: "Czech", code: "cs" },

  { name: "Danish", code: "da" },
  { name: "Dutch", code: "nl" },

  { name: "English", code: "en" },
  { name: "English (UK)", code: "en-GB" },
  { name: "English (US)", code: "en-US" },
  { name: "Esperanto", code: "eo" },
  { name: "Estonian", code: "et" },

  { name: "Faroese", code: "fo" },
  { name: "Fiji", code: "fj" },
  { name: "Finnish", code: "fi" },
  { name: "French", code: "fr" },
  { name: "Frisian", code: "fy" },

  { name: "Galician", code: "gl" },
  { name: "Georgian", code: "ka" },
  { name: "German", code: "de" },
  { name: "Greek", code: "el" },
  { name: "Greenlandic", code: "kl" },
  { name: "Gujarati", code: "gu" },

  { name: "Haitian Creole", code: "ht" },
  { name: "Hausa", code: "ha" },
  { name: "Hebrew", code: "he" },
  { name: "Hindi", code: "hi" },
  { name: "Hungarian", code: "hu" },

  { name: "Icelandic", code: "is" },
  { name: "Indonesian", code: "id" },
  { name: "Interlingua", code: "ia" },
  { name: "Irish", code: "ga" },
  { name: "Italian", code: "it" },

  { name: "Japanese", code: "ja" },
  { name: "Javanese", code: "jv" },

  { name: "Kannada", code: "kn" },
  { name: "Kashmiri", code: "ks" },
  { name: "Kazakh", code: "kk" },
  { name: "Khmer", code: "km" },
  { name: "Kinyarwanda", code: "rw" },
  { name: "Korean", code: "ko" },
  { name: "Kurdish", code: "ku" },
  { name: "Kyrgyz", code: "ky" },

  { name: "Lao", code: "lo" },
  { name: "Latin", code: "la" },
  { name: "Latvian", code: "lv" },
  { name: "Lithuanian", code: "lt" },

  { name: "Macedonian", code: "mk" },
  { name: "Malay", code: "ms" },
  { name: "Malayalam", code: "ml" },
  { name: "Marathi", code: "mr" },
  { name: "Mongolian", code: "mn" },

  { name: "Nepali", code: "ne" },
  { name: "Norwegian", code: "no" },

  { name: "Occitan", code: "oc" },
  { name: "Oriya", code: "or" },

  { name: "Pashto", code: "ps" },
  { name: "Persian", code: "fa" },
  { name: "Polish", code: "pl" },
  { name: "Portuguese", code: "pt" },
  { name: "Portuguese (Brazil)", code: "pt-BR" },
  { name: "Portuguese (Portugal)", code: "pt-PT" },
  { name: "Punjabi", code: "pa" },

  { name: "Quechua", code: "qu" },

  { name: "Romanian", code: "ro" },
  { name: "Russian", code: "ru" },

  { name: "Samoan", code: "sm" },
  { name: "Sanskrit", code: "sa" },
  { name: "Scots Gaelic", code: "gd" },
  { name: "Serbian", code: "sr" },
  { name: "Sindhi", code: "sd" },
  { name: "Sinhala", code: "si" },
  { name: "Slovak", code: "sk" },
  { name: "Slovenian", code: "sl" },
  { name: "Somali", code: "so" },
  { name: "Spanish", code: "es" },
  { name: "Sundanese", code: "su" },
  { name: "Swahili", code: "sw" },
  { name: "Swedish", code: "sv" },

  { name: "Tamil", code: "ta" },
  { name: "Telugu", code: "te" },
  { name: "Thai", code: "th" },
  { name: "Tibetan", code: "bo" },
  { name: "Tigrinya", code: "ti" },
  { name: "Tongan", code: "to" },
  { name: "Turkish", code: "tr" },
  { name: "Turkmen", code: "tk" },

  { name: "Ukrainian", code: "uk" },
  { name: "Urdu", code: "ur" },
  { name: "Uzbek", code: "uz" },

  { name: "Vietnamese", code: "vi" },

  { name: "Welsh", code: "cy" },

  { name: "Xhosa", code: "xh" },

  { name: "Yiddish", code: "yi" },
  { name: "Yoruba", code: "yo" },

  { name: "Zulu", code: "zu" },
];

const LanguageSection = ({
  languages = [],
  onAdd,
  onEdit,
  onDelete,
  isDisabled,
}) => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState(emptyLanguage);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [loadingLanguages, setLoadingLanguages] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchLanguages();
  }, []);

  const validateLanguage = (data) => {
    const newErrors = {};

    if (!data.languageName || data.languageName.trim() === "") {
      newErrors.languageName = "Language is required";
    }
    if (
      languages?.some(
        (l) =>
          l.languageName?.toLowerCase() === data.languageName?.toLowerCase()
      )
    ) {
      newErrors.languageName = "Language already exists";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchLanguages = async () => {
    try {
      setLoadingLanguages(true);

      const uniqueSorted = MANUAL_LANGUAGES.filter(
        (v, i, a) =>
          a.findIndex(
            (item) => item.name.toLowerCase() === v.name.toLowerCase()
          ) === i
      ).sort((a, b) => a.name.localeCompare(b.name));

      setLanguageOptions(uniqueSorted);
    } catch (err) {
      console.error("Language load failed", err);
    } finally {
      setLoadingLanguages(false);
    }
  };

  const handleAddSave = () => {
    if (!validateLanguage(currentLanguage)) return;
    onAdd(currentLanguage);
    setOpenAdd(false);
  };

  const handleEditSave = () => {
    onEdit(currentLanguage);
    setOpenEdit(false);
  };

  return (
    <Box>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ color: themeColor }}
        >
          Language Proficiency
        </Typography>

        <Button
          variant="outlined"
          size="small"
          disabled={isDisabled}
          onClick={() => {
            setCurrentLanguage(emptyLanguage);
            setOpenAdd(true);
          }}
          sx={{
            color: themeColor,
            borderColor: themeColor,
            "&:hover": {
              backgroundColor: `${themeColor}10`,
              borderColor: themeColor,
            },
          }}
        >
          Add Language
        </Button>
      </Box>

      {/* Empty */}
      {languages.length === 0 && (
        <Typography color="text.secondary">No languages added yet</Typography>
      )}

      {/* List */}
      <Stack spacing={1.5}>
        {languages.map((lang) => (
          <Box
            key={lang.languageId}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            border="1px solid"
            borderColor="divider"
            borderRadius={2}
            sx={{
              "&:hover": { backgroundColor: `${themeColor}08` },
            }}
          >
            <Box>
              <Typography fontWeight={600}>{lang.languageName}</Typography>

              <Stack direction="row" spacing={1} mt={0.5}>
                <Chip
                  label={lang.level}
                  size="small"
                  variant="outlined"
                  sx={{ color: themeColor, borderColor: themeColor }}
                />
                <Typography variant="subtitle2">Proficiency :</Typography>
                {lang.canSpeak && <Chip size="small" label="Speak" />}
                {lang.canWrite && <Chip size="small" label="Write" />}
                {lang.canRead && <Chip size="small" label="Read" />}
              </Stack>
            </Box>

            <Stack direction="row">
              <IconButton
                size="small"
                sx={{ color: themeColor }}
                disabled={isDisabled}
                onClick={() => {
                  setCurrentLanguage(lang);
                  setOpenEdit(true);
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="error"
                disabled={isDisabled}
                onClick={() => onDelete(lang.languageId)}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
        ))}
      </Stack>

      {/* ADD Dialog */}
      <Dialog open={openAdd} onClose={() => setOpenAdd(false)} fullWidth>
        <DialogTitle sx={{ color: themeColor }}>Add Language</DialogTitle>
        <DialogContent>
          <LanguageForm
            language={currentLanguage}
            setLanguage={setCurrentLanguage}
            languageOptions={languageOptions}
            errors={errors}
            loadingLanguages={loadingLanguages}
          />
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            px: 3,
            pb: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleAddSave}
            sx={{
              backgroundColor: themeColor,
              color: "#fff",
              "&:hover": {
                backgroundColor: "#245a7b",
              },
              "&:active": {
                backgroundColor: "#1f4e6a",
              },
            }}
          >
            Save
          </Button>
          <Button
            sx={{
              color: themeColor,
              "&:hover": {
                backgroundColor: `${themeColor}10`,
              },
            }}
            onClick={() => setOpenAdd(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* EDIT Dialog */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth>
        <DialogTitle>Edit Language</DialogTitle>
        <DialogContent>
          <LanguageForm
            language={currentLanguage}
            setLanguage={setCurrentLanguage}
            languageOptions={languageOptions}
            loadingLanguages={loadingLanguages}
            errors={errors}
          />
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "flex-start",
            gap: 1,
            px: 3,
            pb: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleEditSave}
            sx={{
              backgroundColor: themeColor,
              color: "#fff",
              "&:hover": {
                backgroundColor: "#245a7b",
              },
              "&:active": {
                backgroundColor: "#1f4e6a",
              },
            }}
          >
            Update
          </Button>
          <Button
            onClick={() => setOpenEdit(false)}
            sx={{
              color: themeColor,
              "&:hover": {
                backgroundColor: `${themeColor}10`,
              },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

/* ---------- Form ---------- */
const LanguageForm = ({
  language,
  setLanguage,
  languageOptions,
  loadingLanguages,
  errors,
}) => (
  <Box mt={1}>
    <Autocomplete
      options={languageOptions}
      getOptionLabel={(option) => option.name}
      loading={loadingLanguages}
      disabled={loadingLanguages}
      value={
        languageOptions.find((l) => l.name === language.languageName) || null
      }
      onChange={(event, newValue) => {
        setLanguage({
          ...language,
          languageName: newValue?.name || "",
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Language"
          margin="normal"
          fullWidth
          error={Boolean(errors.languageName)}
          helperText={errors.languageName}
          placeholder="Search language..."
        />
      )}
      isOptionEqualToValue={(option, value) => option.name === value.name}
    />

    <TextField
      select
      fullWidth
      margin="normal"
      label="Level"
      value={language.level}
      onChange={(e) => setLanguage({ ...language, level: e.target.value })}
    >
      {LANGUAGE_LEVELS.map((l) => (
        <MenuItem key={l.value} value={l.value}>
          {l.label}
        </MenuItem>
      ))}
    </TextField>

    <Stack direction="row" spacing={2} mt={1}>
      <Typography variant="subtitle1" alignSelf="center">
        Proficiency:
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={language.canSpeak}
            onChange={(e) =>
              setLanguage({ ...language, canSpeak: e.target.checked })
            }
          />
        }
        label="Speak"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={language.canWrite}
            onChange={(e) =>
              setLanguage({ ...language, canWrite: e.target.checked })
            }
          />
        }
        label="Write"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={language.canRead}
            onChange={(e) =>
              setLanguage({ ...language, canRead: e.target.checked })
            }
          />
        }
        label="Read"
      />
    </Stack>
  </Box>
);

export default LanguageSection;
